import { ViewIds } from '@ardoq/api-types';
import { TableviewWrapper, setup } from './common/tableviewWrapper';
import { createViewModel$ } from './componentTableViewModel$';
import { KnowledgeBaseLink } from '@ardoq/knowledge-base';
import { TableViewProps } from './common/types';

const ComponentTableViewBase = ({
  viewState,
  viewModel,
  locale,
  i18nLocale,
  userHasWriteAccess,
}: TableViewProps) => (
  <TableviewWrapper
    viewId={ViewIds.TABLEVIEW}
    name="Tableview"
    sortable
    viewState={viewState}
    viewModel={viewModel}
    knowledgeBaseLink={KnowledgeBaseLink.TABLES}
    locale={locale}
    i18nLocale={i18nLocale}
    userHasWriteAccess={userHasWriteAccess}
  />
);

export const ComponentTableView = setup(
  ViewIds.TABLEVIEW,
  ComponentTableViewBase,
  createViewModel$
);
